// extracted by mini-css-extract-plugin
module.exports = {"app":"Layout_app__2JzBe","main":"Layout_main__1dFZc","sidebarToggle":"Layout_sidebarToggle__li3dz","title":"Layout_title__2Nztc","toast":"Layout_toast__qj4j0"};